import * as stepActions from "./step.actions";
import * as fieldActions from "./field.actions";
import * as swimlaneActions from "./swimlane.actions";
import * as ruleActions from "./rule.actions";
import * as processActions from "./process.actions";
import * as appSettingsActions from "./appSettings.actions";
import * as miscActions from "./misc.actions";
import * as assistActions from "./assist.actions";
import * as ecaActions from "./eca.actions";
import * as dataObjectActions from "./dataObject.actions";

const { importRawSwimlanes, ...swimlaneActionsToExport } = swimlaneActions;
const { importRulesToStudio, ...ruleActionsToExport } = ruleActions;

export const studioAPIActions = {
  ...stepActions,
  ...fieldActions,
  ...swimlaneActionsToExport,
  ...ruleActionsToExport,
  ...processActions,
  ...appSettingsActions,
  ...miscActions,
  ...assistActions,
  ...ecaActions,
  ...dataObjectActions
};
